import { useEffect, useState } from "react";

export default function UpdateNotifier() {
  const [show, setShow] = useState(false);
  const [serverVersion, setServerVersion] = useState(null);

  useEffect(() => {
    const checkVersion = () => {
      fetch("/version.json?t=" + Date.now())
        .then((res) => res.json())
        .then((data) => {
          const current = localStorage.getItem("app_version");

          if (!current) {
            localStorage.setItem("app_version", data.version);
            return;
          }

          if (current !== String(data.version)) {
            setServerVersion(data.version);
            setShow(true);
          }
        })
        .catch(() => {});
    };

    checkVersion();
    const interval = setInterval(checkVersion, 30000);

    return () => clearInterval(interval);
  }, []);

  if (!show) return null;

  return (
    <div
      className="position-fixed top-0 start-0 end-0 p-1"
      style={{ zIndex: 9999 }}
    >
      <div className="alert bg-white text-primary shadow d-flex align-items-center justify-content-between mb-0">
        <div className="d-flex align-items-center gap-2">
          <i className="bi bi-arrow-clockwise fs-5"></i>
          <span>
            <strong>New update available</strong>
          </span>
        </div>

        <button
          className="btn btn-primary btn-sm"
          onClick={() => {
            localStorage.setItem("app_version", serverVersion);
            window.location.reload();
          }}
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
